/**

 * Hero reviews badge — loads shop-wide rating + count from Judge.me public API.

 */

(function () {

  function init(root) {

    const token = root.dataset.apiToken?.trim();

    const shopDomain = root.dataset.shopDomain?.trim();

    const fallbackRating = parseFloat(root.dataset.fallbackRating || '4');

    const fallbackCount = parseInt(root.dataset.fallbackCount || '0', 10);

    const starFilled = root.dataset.starFilled;

    const starEmpty = root.dataset.starEmpty;



    if (!token || !shopDomain) {

      render(root, fallbackRating, fallbackCount, starFilled, starEmpty);

      return;

    }



    Promise.all([

      fetchWidget('all_reviews_rating', token, shopDomain),

      fetchWidget('all_reviews_count', token, shopDomain),

    ])

      .then(([rating, count]) => {

        render(

          root,

          Number.isFinite(rating) ? rating : fallbackRating,

          Number.isFinite(count) ? count : fallbackCount,

          starFilled,

          starEmpty

        );

      })

      .catch(() => {

        render(root, fallbackRating, fallbackCount, starFilled, starEmpty);

      });

  }



  async function fetchWidget(widget, token, shopDomain) {

    const url = new URL(`https://judge.me/api/v1/widgets/${widget}`);

    url.searchParams.set('api_token', token);

    url.searchParams.set('shop_domain', shopDomain);



    const response = await fetch(url.toString());

    if (!response.ok) throw new Error(`Judge.me ${widget} ${response.status}`);



    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {

      const data = await response.json();

      return parseNumber(data[widget] ?? data.rating ?? data.count ?? data);

    }



    const text = (await response.text()).trim();

    return parseNumber(text);

  }



  function parseNumber(value) {

    if (typeof value === 'number' && Number.isFinite(value)) return value;

    if (typeof value === 'string') {

      const match = value.match(/[\d.]+/);

      if (match) return parseFloat(match[0]);

    }

    if (value && typeof value === 'object') {

      const nested = Object.values(value).find((entry) => typeof entry === 'number' || /^\d/.test(String(entry)));

      if (nested != null) return parseNumber(nested);

    }

    return NaN;

  }



  function render(root, rating, count, starFilled, starEmpty) {

    const labelEl = root.querySelector('[data-hero-reviews-label]');

    const starsEl = root.querySelector('.hero-reviews__stars');



    const displayRating = Math.max(0, Math.min(5, rating));

    const roundedRating = Math.round(displayRating * 10) / 10;

    const displayCount = Math.max(0, Math.round(count));

    const fullStars = Math.floor(displayRating + 0.25);



    if (labelEl) {

      labelEl.textContent = `${roundedRating}/5 based on ${displayCount} reviews`;

    }



    if (starsEl && starFilled && starEmpty) {

      starsEl.setAttribute('aria-label', `${roundedRating} out of 5 stars`);

      starsEl.innerHTML = '';



      for (let i = 1; i <= 5; i++) {

        const star = document.createElement('span');

        star.className = 'hero-reviews__star';

        star.setAttribute('aria-hidden', 'true');



        const img = document.createElement('img');

        img.src = i <= fullStars ? starFilled : starEmpty;

        img.alt = '';

        img.width = 16;

        img.height = 16;

        img.loading = 'lazy';

        img.decoding = 'async';

        star.appendChild(img);

        starsEl.appendChild(star);

      }

    }

  }



  document.querySelectorAll('[data-hero-reviews]').forEach(init);

})();

